/** @jsxImportSource @emotion/react */

import { fabric } from 'fabric';

import { ImagePlus } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import { useFilePicker } from 'ud-form/components/file-picker';
import customization from 'modules/overlay-canvas/addons/customization';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal } from 'modules/template-editor/store/editor/selectors';
import { useEditorManager } from 'modules/template-editor/ui/context';

export function AddImage() {
  const { t } = useLingui();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useEditorManager();
  const onLoadImage = (file: File) => {
    if (!fabricManager) return;
    const reader = new FileReader();
    reader.onload = function (e) {
      if (e === null) return;
      if (e.target === null) return;
      const src = e.target.result;
      if (typeof src === 'string') {
        fabric.Image.fromURL(src, function (oImg) {
          const { left, top } = fabricManager.getLeftTopCurVP();
          oImg.set({
            left,
            top,
            ...customization.getAllProperties(),
          });
          fabricManager.canvas.setActiveObject(oImg);
          fabricManager.canvas.add(oImg);
        });
      }
    };
    reader.readAsDataURL(file);
  };

  const picker = useFilePicker({ accept: 'image/*', onPick: onLoadImage });

  const onClickUploadImage = () => {
    if (!fabricManager) return;
    picker.open();
  };

  return (
    <>
      {picker.input}
      <UDTippy disabled={Boolean(activeModal)} content={t`Загрузить изображение`} size="xs">
        <span style={{ display: 'inline-block' }}>
          <UDIconButton variant="ghost" icon={<ImagePlus size={20} strokeWidth={1.5} />} onClick={onClickUploadImage} tabIndex={0} />
        </span>
      </UDTippy>
    </>
  );
}
